<div class="dialog-content">
  <h1 mat-dialog-title>
    {{ 'administration.user.item.userRoles.title' | translate }}
  </h1>
  <div mat-dialog-content>
    <div class="radio-group">
      <div class="radioGroup__title">
        {{ 'administration.user.item.userRoles.dialog.selectRole' | translate }}
      </div>
      <mat-radio-group aria-labelledby="filter-radio-group-label" class="group">
        <div *ngFor="let group of roles | keyvalue" class="group">
          <div class="radio__title">
            {{ group.key | startCase | titlecase }}
          </div>

          <mat-radio-button
            class="filter-radio-group"
            *ngFor="let role of group.value | sortBy : 'asc'"
            [value]="group.key + ':' + role"
            [checked]="isRoleChecked(group.key, role)"
            (change)="changeRoles($event)"
          >
            {{ 'administration.user.item.userRoles.roles.' + role | translate }}
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ui-action-button [action]="buttonAction.Apply" (buttonClick)="confirm()"></ui-action-button>
  </div>
</div>
